/**
 * Cliente API de pilas (Sprint 19a RP-04 — venta en un solo paso).
 *
 * Las pilas siguen flujo distinto a LL/CR (D-S17-4): no usan
 * SolicitudRecurso. El rediseño Sprint 19a unifica venta y consumo en un
 * solo paso: `POST /pilas/vender` descuenta el stock (FIFO) y genera el
 * cobro (IngresoVario por_cobrar) a la vez. Reemplaza los antiguos
 * `/pilas/venta-directa` + `/pilas/consumir`.
 */
import { apiFetch } from './client';
import type { IngresoVarioRead } from './ingresos-varios';
import type { PilaVentaIn } from './types';

/** POST /pilas/vender — vende N pilas a una casa en un solo paso. */
export function venderPilas(data: PilaVentaIn): Promise<IngresoVarioRead> {
  return apiFetch<IngresoVarioRead>('/pilas/vender', {
    method: 'POST',
    body: JSON.stringify(data),
  });
}
